import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { positioning } from '@/mocks/about';

export default function Positioning() {
  return (
    <section id="positioning" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="不是一家普通软件公司"
            en="Company Positioning"
            subtitle="华辉数智技术是一家面向县域与乡村场景的人工智能应用服务商，承担核心技术系统的研发、交付与系统集成。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {positioning.map((item, i) => (
            <Reveal key={item.title} delay={i * 100}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-600 text-2xl`}></i>
                  </div>
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}